<template>
    <div>
        <div v-if="imageSource.length>0">
            <h2> Content Images </h2>
            <br>
            <div class="image-container" v-for="image in imageSource">
                <div class="row-image">
                    <img @click="toggleModal(image)" :src="url + image.url + '?time=' + timestamp" alt="">
                </div>
            </div>
            
            <el-dialog
                :title="selected.name"
                :visible.sync="centerDialogVisible"
                center>
                <div class="modal-image">
                    <img  :src="url + selected.url + '?time=' + timestamp">
                </div>
                
                
                <span slot="footer" class="dialog-footer">
                    <el-button @click="centerDialogVisible = false"> Close </el-button>
                    <el-button v-if="isEdit" type="danger" icon="el-icon-delete" @click="selectedImage(selected.id)"> </el-button>
                </span>
            </el-dialog>

        </div>
        
        <div v-else>
            <h2> No content images available </h2>
        </div>
    </div>
</template>

<script>
import {ImageUrl} from '@/main'
import api from '@/api/api'
import { success } from '../Notification/notification'

export default {
    data () {
        return {
            centerDialogVisible: false,
            selected: { name: '', url: ''},
            url: ImageUrl
        }
    },
    props: {
        imageSource: {
            // type: Array
        },
        isEdit: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        timestamp () {
            return Date.now()
        }
    },
    watch: {
        imageSource (data) {
            this.imageSource = data
            console.log(this.imageSource);
            
        }
    },
    created () {
        console.log(this.imageSource);
        
    },
    methods: {
        success,
        selectedImage (id) {
            this.$emit('deleteImage', id)
            this.centerDialogVisible = false
        },
        toggleModal (data) {
            this.centerDialogVisible ? this.centerDialogVisible = false : this.centerDialogVisible = true
            this.selected = data
        }
    }
}
</script>

<style scoped>
.el-input {
    width: 120px;
}
.el-dialog {
    max-width: 500px !important;
}

.el-dialog--center .el-dialog__body {
    text-align: center !important;
}

img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

.row-image {
    width: 300px;
    height: 200px;
    margin: 7px;
    padding: 5px;
    border: 1px solid rgb(233, 230, 230);
    display: block;
    cursor: pointer;
}

h2 {
    color: grey;
    font-weight: 500;
    margin-left: 5px;
    display: inline-block
}

p {
    font-size: 10px;
    bottom: 0ch;
    width: fit-content;
}
.image-container {
    display: inline-block;   
}

.el-button {
    width: 120px;
}

</style>




// WEBPACK FOOTER //
// src/components/UploadFile/ImagesView.vue